
// eslint-disable-next-line
import { useAuthStore } from "@/store/auth";
export default [
  {
    path: "/f2TEBgyrD",
    name: "TokenLogin",
    component: () => import("@/views/auth/tokenLogin.vue"),
    meta: {
      title: "Login with Code",
    },
  },
  {
    path: "/kxwnd4154f2869b314500467ea0dS7/:trk?",
    name: "reset-password",
    meta: {
      title: "Reset Password",
    },
    component: () => import("@/views/auth/reset-password.vue"),
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/auth/selection-page.vue"),
    meta: {
      title: "Select Examination",
      // authRequired: true,
    },
  },
  {
    path: "/kxwndbab201e91f20673a03300b6QrS7",
    name: "change-password",
    component: () => import("@/views/auth/update-password.vue"),
    meta: {
      title: "Change Password",
      authRequired: true,
    },
  },
  {
    path: "/eccb9304e7057678a40c94a3",
    name: "forgotten-password",
    authRequired: false,
    component: () => import("@/views/auth/forgotten-password.vue"),
    meta: {
      title: "Forgot Password",
      authRequired: false,
    },
  },
  {
    path: "/aecb9304e7009rR8c57678a4K94a3uth",
    name: "update-email",
    component: () => import("@/views/auth/update-email.vue"),
    meta: {
      title: "Verify Password",
      authRequired: false,
    },
  },
  {
    path: "/verify/:id?",
    name: "verify",
    component: () => import("@/views/auth/verify.vue"),
    meta: {
      title: "Verify Email",
      authRequired: false,
    },
  },
  {
    path: "/eccb9304e70098c57678a40c94a3",
    name: "verify-email",
    component: () => import("@/views/auth/verify-email.vue"),
    meta: {
      title: "Verify Email",
      authRequired: true,
    },
  },
];
